export const latexKeys = ['template', 'validation.validResponse.value.value']
